export default __webpack_public_path__ + "static/MOVE2-5c35c3e677a1c4c95ac270d370f7d0bd.svg";